import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatNativeDateModule, MatPaginatorModule, MatSelectModule, MatSortModule, MatTableModule } from '@angular/material';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { RouterModule, Routes } from '@angular/router';
import { SupportTicketAdminComponent } from './support-ticket-admin.component';

const routes: Routes = [
    {
        path: '',
        component: SupportTicketAdminComponent,
        data: {
            title: 'Support Ticket'
        }
    }
];

@NgModule({
    declarations: [SupportTicketAdminComponent],
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatIconModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        FormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
         OwlDateTimeModule,
    OwlNativeDateTimeModule,
        RouterModule.forChild(routes)
    ],
    exports: [RouterModule, SupportTicketAdminComponent],
})
export class SupportTicketAdminModule { }

